module.exports = __webpack_public_path__ + "media/newstyle/images/bb-442b7e33ec916f74e6d74774a7a312cf.svg";